import { createFileRoute } from '@tanstack/react-router';

import { revalidateCustomerCapabilities } from 'shared/modules/capabilities';

export const Route = createFileRoute('/_authenticated/locations/$id/_shell/ai-visibility')({
  staticData: { breadcrumb: 'aiVisibility' },
  // AI Visibility has no location tool code yet, so the pages' gate reads only the customer capabilities.
  // Refreshing them here keeps the pages from rendering from stale access.
  loader: ({ context: { queryClient }, location }) =>
    revalidateCustomerCapabilities({ queryClient, attemptedHref: location.href })
});
